import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import intl from 'react-intl-universal'
import { LeftOutline } from 'antd-mobile-icons'
import { Card, Button, FloatingBubble } from 'antd-mobile'
import { formatJSON, replaceCDNDomain } from '../../utils'
import Header from '../../components/Header'
import Article from '../../components/Article'

import './index.less'

export default function FacilityDetail(props) {
    const location = useLocation()
    const { item, callback } = props
    const navigate = useNavigate()
    const obj = item || location.state || {}

    const { title, image, content, showType, extraInfoJson = {} } = obj


    const cObj = formatJSON(content)
    const list = cObj ? Object.values(cObj) : []
    console.log('list', list)


    console.log(title, '////=====title=====')

    return (
        <div className='fac-box'>
            <Header title={title} callback={callback} useTitle={true} />
            <div className='fac-main'>
                <div className='p10'>
                    <img className='fac-img' src={replaceCDNDomain(image)} alt={title} />
                </div>
                <div className='fac-content'>
                    <Card title={intl.get('h_detail').d('详情')}>
                        <Article list={list} />
                    </Card>
                </div>
            </div>
            <div style={{ height: 80 }}>&nbsp;</div>
            {
                showType === 4 && (
                    <div className='fac-book-btn p10'>
                        <Button
                            block
                            shape='rounded'
                            color='primary'
                            onClick={() => {
                                callback?.()
                                navigate(`/shuttle-bus?partner=${extraInfoJson.channelId}&dest=${extraInfoJson.partnerId}`)
                            }}>
                            {intl.get('equity_book_bus').d('Book a shuttle')}
                        </Button>
                    </div>
                )
            }

            <FloatingBubble
                axis='xy'
                style={{
                    '--background': 'var(--adm-color-primary)',
                    '--initial-position-bottom': '100px',
                    '--initial-position-right': '10px',
                    '--edge-distance': '10px',
                }}
            >
                <div
                    
                    onClick={() => {
                        callback?.()
                    }}>
                    <LeftOutline fontSize={20}  color='#fff'/>
                </div>
            </FloatingBubble>

        </div>
    )
}
